package org.example.zone360.pages.authentication

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.stevdza.san.kotlinbs.models.ToastPlacement
import com.stevdza.san.kotlinbs.models.ToastStyle
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.createPlayer
import kotlinx.browser.document
import kotlinx.coroutines.launch
import org.example.zone360.components.BSToastBasicCustom
import org.example.zone360.components.BSToastGroupCustom
import org.example.zone360.components.CommonButton
import org.example.zone360.components.InputField
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleText
import org.example.zone360.componentss.FieldTitleTextNormal
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.UserData
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.Strings
import org.example.zone360.utils.isValidEmail
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Page("/playersignup")
@Composable
fun SignupPage() {
    val scope = rememberCoroutineScope()
    val context = rememberPageContext()
    val sitePalette = ColorMode.current.toSitePalette()

    var showPassword by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    var isError by remember { mutableStateOf(false) }
    var serverError by remember { mutableStateOf(" ") }
    var message by remember { mutableStateOf("") }
    var showConfirmPassword by remember { mutableStateOf(false) }

    val performSignup = {
        if (!isLoading) {
            scope.launch {
                val email = (document.getElementById(Res.Id.emailInput) as HTMLInputElement).value
                val password =
                    (document.getElementById(Res.Id.passwordInput) as HTMLInputElement).value
                val confirmPassword =
                    (document.getElementById(Res.Id.confirmPasswordInput) as HTMLInputElement).value
                val firstName =
                    (document.getElementById(Res.Id.firstName) as HTMLInputElement).value
                val lastName = (document.getElementById(Res.Id.lastName) as HTMLInputElement).value

                when {
                    firstName.isEmpty() || lastName.isEmpty() -> {
                        isError = true
                    }

                    email.isEmpty() -> {
                        isError = true
                    }

                    !isValidEmail(email) -> {
                        isError = true
                    }

                    password.isEmpty() || confirmPassword.isEmpty() -> {
                        isError = true
                    }

                    password != confirmPassword -> {
                        isError = true
                        serverError = "Passwords do not match"
                        return@launch
                    }

                    else -> {
                        isLoading = true
                        isError = false

                        try {
                            val result = createPlayer(
                                email = email,
                                password = password,
                                firstName = firstName,
                                lastName = lastName,
                                imageUrl = "",
                                coachName = "",
                                team = "",
                                organization = Strings.INDEPENDENT,
                                isPublicSignup = true
                            )

                            if (!result.data.isNullOrBlank()) {
                                AppGlobal.userData = result.userData ?: UserData()
                                message = "Sign Up successful!"
                                context.router.navigateTo("/player-details") // ✅ Move before toast
                                showToast("toastSuccess")
                            } else {
                                message = result.error ?: "Unexpected error"
                                serverError = result.error ?: "Unexpected error"
                            }
                        } catch (e: Exception) {
                            serverError = e.message ?: "Unexpected error"
                            message = "Sign Up Failed!"
                            showToast("toastError")
                        }finally {
                            isLoading = false
                        }
                    }

                }
            }
        }
    }
    Box (Modifier.fillMaxSize()){

    BSToastGroupCustom(
        placement = ToastPlacement.TopRight,
    ) {
        BSToastBasicCustom(id = "toastSuccess",
            text = message,
            style = ToastStyle.Success,
            autoHide = true,
            closeButtonDark = false,
            onCloseClick = {})
        BSToastBasicCustom(id = "toastError",
            text = message,
            style = ToastStyle.Danger,
            autoHide = true,
            closeButtonDark = false,
            onCloseClick = {})
    }

    Box(
        Modifier.fillMaxSize().color(sitePalette.bodyBackground.rgb),
        contentAlignment = Alignment.Center
    ) {
        Box(
            Modifier.color(Colors.Black).backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .maxWidth(400.px).borderRadius(6.px), contentAlignment = Alignment.Center
        ) {
            Column(Modifier.padding(topBottom = 40.px, leftRight = 30.px)) {
                FieldTitleText(text = "Player Sign Up")

                FieldTitleTextNormal(text = "First Name", marginTop = 10.px) {}
                InputField(
                    "Enter your first name", InputType.Text, "", Res.Id.firstName, isError, 3.px
                )

                FieldTitleTextNormal(text = "Last Name", marginTop = 10.px) {}
                InputField(
                    "Enter your last name", InputType.Text, "", Res.Id.lastName, isError, 3.px
                )

                FieldTitleTextNormal(text = "Email", marginTop = 10.px) {}
                InputField(
                    "Please enter a valid email",
                    InputType.Email,
                    "",
                    Res.Id.emailInput,
                    isError, 3.px,

                )

                Row(
                    Modifier.fillMaxWidth().margin(top = 10.px),
                    horizontalArrangement = Arrangement.SpaceBetween,
                ) {
                    FieldTitleTextNormal(text = "Password") {}
                    FieldTitleTextNormalSimple(
                        text = if (showPassword) "Hide" else "Show",
                        onClick = { showPassword = !showPassword },
                        isClickable = true,
                        color = sitePalette.primary.rgb
                    )
                }
                InputField(
                    errorText = "Enter your password",
                    inputType = if (showPassword) InputType.Text else InputType.Password,
                    placeHolder = "",
                    id = Res.Id.passwordInput,
                    isError = isError,
                    marginBottom = 3.px,
                )

                Row(
                    Modifier.fillMaxWidth().margin(top = 10.px),
                    horizontalArrangement = Arrangement.SpaceBetween,
                ){
                    FieldTitleTextNormal(text = "Confirm Password") {}
                    FieldTitleTextNormalSimple(
                        text = if (showConfirmPassword) "Hide" else "Show",
                        onClick = { showConfirmPassword = !showConfirmPassword },
                        isClickable = true,
                        color = sitePalette.primary.rgb
                    )}
                InputField(
                    errorText = "Re-enter your password",
                    inputType = if (showConfirmPassword) InputType.Text else InputType.Password,
                    placeHolder = "",
                    id = Res.Id.confirmPasswordInput,
                    isError = isError,
                    marginBottom = 3.px,
                    onEnterPress = performSignup
                )

                Box(Modifier.margin(topBottom = 10.px)) { }
                CommonButton(text = "Sign Up", isLoading = isLoading, onCLick = { performSignup() })

                Box(
                    modifier = Modifier.margin(topBottom = 10.px).fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(text = serverError,
                        fontSize = 13.px,
                        color = sitePalette.textErrorColor.rgb,
                        onClick = {})
                }

                Box(
                    modifier = Modifier.margin(bottom = 0.px).fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    FieldTitleTextNormalSimple(text = Constants.VERSION,
                        fontSize = 11.px,
                        color = Palette.EditTextBorder.rgbLight,
                        onClick = {})
                }
            }
            }
        }
    }
}




